import {
  REDIRECT_LOOP_STORAGE_PREFIX,
  REDIRECT_LOOP_WINDOW_MS,
  REDIRECT_LOOP_THRESHOLD,
} from "@/utils/constants";

export { LOOP_REDIRECT_QUERY_PARAM } from "@/utils/constants";

const getOrigin = (url: string): string | null => {
  try {
    return new URL(url).origin;
  } catch {
    return null;
  }
};

const readTimestamps = (origin: string): number[] => {
  try {
    const raw = sessionStorage.getItem(REDIRECT_LOOP_STORAGE_PREFIX + origin);
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) ? parsed.filter((n): n is number => typeof n === "number") : [];
  } catch {
    return [];
  }
};

const writeTimestamps = (origin: string, timestamps: number[]) => {
  try {
    sessionStorage.setItem(REDIRECT_LOOP_STORAGE_PREFIX + origin, JSON.stringify(timestamps));
  } catch {
    // sessionStorage unavailable (private mode etc.) — guard becomes a no-op
  }
};

const prune = (timestamps: number[], now: number): number[] =>
  timestamps.filter((t) => now - t < REDIRECT_LOOP_WINDOW_MS);

export const recordRedirectAttempt = (redirectUrl: string): { isLooping: boolean; origin: string | null } => {
  const origin = getOrigin(redirectUrl);
  if (!origin) return { isLooping: false, origin: null };

  const now = Date.now();
  const recent = prune(readTimestamps(origin), now);
  recent.push(now);
  // Cap stored entries: once the threshold is reached the guard is "tripped"
  // and keeps tripping, so there's no need to grow the array unbounded.
  writeTimestamps(origin, recent.slice(-REDIRECT_LOOP_THRESHOLD));

  return { isLooping: recent.length >= REDIRECT_LOOP_THRESHOLD, origin };
};

export const clearRedirectLoopFor = (origin: string) => {
  try {
    sessionStorage.removeItem(REDIRECT_LOOP_STORAGE_PREFIX + origin);
  } catch {
    // ignore
  }
};
